import { Suspense, type ReactNode } from 'react';
import { Spin } from 'antd';

// Loading fallback component
const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
    <Spin size='large' />
  </div>
);

// Wrapper component for lazy loaded pages with Suspense
interface LazyWrapperProps {
  children: ReactNode;
}

export const LazyWrapper = ({ children }: LazyWrapperProps) => (
  <Suspense fallback={<PageLoader />}>{children}</Suspense>
);
